<template>
  <div class="claim__passenger--add-non-passenger">
    <div class="data-edit data-edit--gradient">
      <form-factory
        :record="currentPerson"
        :layout="fieldLayout"
        :submitText="getUiString(['claim_details', 'details', 'passengers', 'save_new_button'])"
        :cancelText="getUiString(['claim_details', 'details', 'passengers', 'cancel_Button'])"
        :hasError="error"
        :isLegalRepresentative="true"
        @submit="saveSettings"
        @blurfield="checkAddress"
        @reset="$emit('cancel-edit-person')"
      >
        <h3 class="title--m">{{ formTitle }}</h3>
      </form-factory>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getFieldKeys } from '@/utils/formComposition.js'

export default {
  name: 'AddNonPassenger',
  props: {
    IsBirthPlaceRequired: {
      type: Boolean,
      required: false
    }
  },
  data: function () {
    return {
      currentPerson: null,
      error: false,
      chkPc: '',
      chkHn: '',
      hasAddressError: false
    }
  },
  beforeMount () {
    this.currentPerson = { ...this.emptyPerson }
  },
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString',
      emptyPerson: 'claim/getEmptyPerson'
    }),
    hasAddressCheck () {
      return (!!this.chkPc && !!this.chkHn) || this.hasAddressError
    },
    hasBirthDateCheck () {
      return this.hasBirthDateError
    },
    getErrorClass () {
      return this.error ? 'form__group--error' : ''
    },
    fieldLayout () {
      let fieldKeys = getFieldKeys(this.hasAddressCheck ? 'nonPassengerWithAddress' : 'nonPassenger')

      if (!this.IsBirthPlaceRequired) {
        fieldKeys = Array.isArray(fieldKeys[0])
          ? fieldKeys.map(group => group.filter(field => field !== 'BirthPlace'))
          : fieldKeys.filter(field => field !== 'BirthPlace')
      }

      return fieldKeys || []
    },
    formTitle () {
      const labelStart = this.getUiString([
        'claim_details',
        'details',
        'passengers',
        'create_person_title'
      ])
      const sep =
        this.currentPerson.FirstName || this.currentPerson.LastName
          ? ' - '
          : ''
      return `${labelStart}${sep}${this.currentPerson.FirstName} ${this.currentPerson.LastName}`
    }
  },
  methods: {
    async checkAddress (fielddata) {
      this.currentPerson[fielddata.field] = fielddata.value
      if (this.currentPerson.PostalCode && this.currentPerson.HouseNumber) {
        if (this.currentPerson.PostalCode !== this.chkPc || this.currentPerson.HouseNumber !== this.chkHn) {
          this.chkPc = this.currentPerson.PostalCode
          this.chkHn = this.currentPerson.HouseNumber
          this.busy = true
          const result = await this.$store.dispatch('claim/findAddress', {
            postalCode: this.currentPerson.PostalCode,
            houseNumber: this.currentPerson.HouseNumber
          })
          if (result) {
            this.hasAddressError = false
            this.currentPerson = { ...this.currentPerson, StreetName: result.Street, City: result.Town }
          } else {
            this.hasAddressError = true
            this.currentPerson = { ...this.currentPerson, StreetName: '', City: '' }
          }
          this.busy = false
        }
      }
    },
    saveSettings (record) {
      this.busy = true
      this.currentPerson = { ...record }

      this.currentPerson.LegalRepresentativeLinkType = 'NonPassenger'

      this.$store
        .dispatch('claim/addNonPassenger', this.currentPerson)
        .then(
          result => {
            this.currentPerson = { Id: result.Id, ...record }
            this.$emit('end-edit-person', this.currentPerson)
          },
          err => {
            this.$emit('edit-person-error', err)
          }
        )
        .finally(() => {
          this.busy = false
        })
    }

  }
}
</script>
